module.exports = __webpack_public_path__ + "assets/search-1aba22.svg";